module.exports = __webpack_public_path__ + "assets/img/3.2b82a975.jpg";